module.exports = __webpack_public_path__ + "8dc6f2b81c715abc1d2551eb444194b8.svg";